import forge from "node-forge";
import $api from "../http";

class EncryptionServiceClass {
  async getKey() {
    const { data } = await $api.get<{ publicKey: string }>("api/crypto/public-key");
    return data.publicKey;
  }

  async encrypt(data: any): Promise<string> {
    try {
      const publicKeyPem = await this.getKey();
      const publicKey = forge.pki.publicKeyFromPem(publicKeyPem);
      const encryptedBytes = publicKey.encrypt(JSON.stringify(data), "RSA-OAEP");
      return forge.util.encode64(encryptedBytes);
    } catch (error) {
      console.error("Encryption failed:", error);
      return "";
    }
  }
}

export const EncryptionService = new EncryptionServiceClass();
